<div>
    <form nz-form [nzLayout]="'vertical'">
        @if (userEmail && !users && !user && !userEmails) {
            <p><strong>Saņēmējs: </strong>{{ userEmail }}</p>
        } 
        @else if (userEmails && !users && !user && !userEmail) {
            <p><strong>Saņēmēji: </strong>{{ userEmails.join(', ') }}</p>
        }
        @else if (user && !users && !userEmail && !userEmails) {
            <p><strong>Saņēmējs: </strong>{{ userToString(user) }}</p>
        }  @else if (multipleUsers && users && !user && !userEmail && !userEmails) {
            <nz-select
                nzShowSearch
                nzPlaceHolder="Lietotāji"
                [(ngModel)]="notificationModel.receiverUserIds"
                [ngModelOptions]="{ standalone: true }"
                nzAllowClear
                nzMode="multiple"
                class="w-100"
            >
                @for (user of users; track user.id) {
                    <nz-option [nzLabel]="userToString(user)" [nzValue]="user.id"></nz-option>
                }
            </nz-select>
        }
        @else if (users && !user && !userEmail && !userEmails) {
            <nz-select
                nzShowSearch
                nzPlaceHolder="Lietotājs"
                [(ngModel)]="notificationModel.receiverUserId"
                [ngModelOptions]="{ standalone: true }"
                nzAllowClear
                class="w-100"
            >
                @for (user of users; track user.id) {
                    <nz-option [nzLabel]="userToString(user)" [nzValue]="user.id"></nz-option>
                }
            </nz-select>
        }

        <nz-form-item>
            <nz-form-label>Papildus info (redzama e-pasta tekstā)</nz-form-label>
            <nz-form-control>
                <textarea
                    name="additionalMessage"
                    rows="8"
                    maxlength="512"
                    nz-input
                    placeholder="Papildus info"
                    [(ngModel)]="notificationModel.additionalMessage"
                ></textarea>
            </nz-form-control>
        </nz-form-item>
    </form>
</div>
<div *nzModalFooter>
    <button nz-button nzType="default" (click)="cancel()">Atcelt</button>
    <button nz-button nzType="primary" (click)="submitAndReturn()">Izsūtīt</button>
</div>
